import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { createApiKey } from "../../slices/apikeys";

const ApiKeyForm = () => {

    const dispatch = useDispatch()

    const onSubmit = (data) => {
        dispatch(createApiKey(data))
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors }
    } = useForm();


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <p>
                                <ul>
                                    <li>{gettext('On save, a pair of API keys will be created, one public and one secret.')}</li>
                                    <li>{gettext('After save you will have a chance to copy the keys for safe storage.')}</li>
                                    <li>{gettext('For security reasons you will not we able to view them again.')}</li>
                                    <li><strong>{gettext('If you lose the keys, you will have to create new ones.')}</strong></li>
                                </ul>
                            </p>
                        </div>
                        <div className="col-12 mb-4">
                            <label>{gettext('Name, max length 50 characters')}</label>
                            <input type="text" {...register("name")} className="form-control" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form>
    )
}

export default ApiKeyForm